export default "__VITE_ASSET__C$DO6Y5e__"